import { __extends } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash-es';
import { Button, Flex, Box } from '@marvelapp/ui';
import { InputWithLabel } from '@marvelapp/ui-internal';
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password(props) {
        var _this = _super.call(this, props) || this;
        _this._updateValue = function (e) {
            var value = e.target.value;
            var isSubmittable = !!value;
            _this.setState({ value: value, isSubmittable: isSubmittable });
        };
        _this._onSubmit = function (e) {
            e.preventDefault();
            _this.props.onSubmit(_this.props.projectID, _this.state.value);
        };
        _this.state = {
            value: _this.props.value || '',
            isSubmittable: false,
        };
        return _this;
    }
    Password.prototype.render = function () {
        var _a = this.props, isValid = _a.isValid, isBeingVerified = _a.isBeingVerified;
        var _b = this.state, value = _b.value, isSubmittable = _b.isSubmittable;
        return (React.createElement(Flex, { alignItems: "center", height: "100vh", justifyContent: "center", width: "100vw" },
            React.createElement(Box, { width: 340 },
                React.createElement("form", null,
                    React.createElement(InputWithLabel, { id: "passwordInput", kind: isValid !== null && !isValid ? 'error' : 'default', label: "Enter a password to access", mb: 3, onChange: this._updateValue, placeholder: "Enter password", size: 3, type: "password", value: value, width: "100%" }),
                    React.createElement(Button, { isDisabled: !isSubmittable, isLoading: isBeingVerified, kind: "green", onClick: this._onSubmit, size: 2, type: "submit" }, "Submit")))));
    };
    return Password;
}(React.Component));
export default Password;
Password.propTypes = {
    projectID: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    isBeingVerified: PropTypes.bool,
};
Password.defaultProps = {
    onSubmit: noop,
};
